@if (!isLoading) {
    <app-linkable
        typename="assets"
        displayValueProp="name"
        [linked]="linked"
        [unlinked]="unlinked"
        [orderByValueProperty]="true"
        [disabled]="disabled"
        (onOpenClicked)="openItem($event)"
        [allowOpenItem]="true"
        [hideActions]="true"
        [showAdvancedFilters]="true"
        [activeFilters]="activeFilters"
        [filterConfig]="filterConfig"
        [moduleType]="moduleType"
        (linkedChange)="linkedItemsChanged($event)"
    >
    </app-linkable>
} @else {
    <div class="fancy-loader"></div>
}
